import $ from "jquery";
import 'slick-carousel';

const verticalSlider = () => {
  const sliderId = $("[data-slider='vertical-slider']").attr("id");
  const slider = $(`#${sliderId}`);

  if (!slider.length) {
    return;
  }

  // Check if the current viewport is mobile
  const isMobile = window.matchMedia("(max-width: 840px)").matches;

  // Set slider options based on viewport
  const sliderOptions = {
    infinite: false,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    cssEase: 'linear',
    speed: 350,
    arrows: false,
    dots: false,
    vertical: !isMobile, // Use vertical sliding for non-mobile, horizontal for mobile
    verticalSwiping: !isMobile,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  if (slider.hasClass('slick-initialized')) {
    slider.slick('unslick');
  }
  slider.slick(sliderOptions);

  const prevButton = $(`[data-slider="${sliderId}"][data-type="prev"]`);
  if (prevButton) {
    prevButton.on('click', function () {
      slider.slick('slickPrev');
    });
  }

  const nextButton = $(`[data-slider="${sliderId}"][data-type="next"]`);
  if (nextButton) {
    nextButton.on('click', function () {
      slider.slick('slickNext');
    });
  }

  const updateButtonsState = () => {
    if(!nextButton.length || !prevButton.length) return;

    const currentSlide = slider.slick('slickCurrentSlide');
    const slideCount = slider.slick('getSlick').slideCount;
    const slidesToShow = slider.slick('getSlick').options.slidesToShow;

    if (currentSlide === 0) {
      prevButton.prop('disabled', true);
    } else {
      prevButton.prop('disabled', false);
    }

    if (slideCount <= currentSlide + slidesToShow) {
      nextButton.prop('disabled', true);
    } else {
      nextButton.prop('disabled', false);
    }
  };

  updateButtonsState();

  slider.on('afterChange', function (event, slick, currentSlide) {
    updateButtonsState();
  });
};

export default verticalSlider;
